export default {
  ctaText: "Review my actions",
  sidePanelSubtitle: "Check the financial overview.",
  sidePanelTitle: "End of day!",
  tagLabel: "End of the day"
};
